<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-container fluid class="pb-0" grid-list-xl>
        <v-layout wrap>
          <v-flex md12 lg7 ref="section2">
            <v-layout v-if="!isOriginal">
              <v-flex sm12 md6 lg4>
                <v-combobox
                  v-model="selected"
                  label="* Select lookup type"
                  :items="orderType === 'nbn'
                    ? items
                    : items.filter(x => 
                        (orderType !== '5G' && (orderType === 'Business Fibre' && x === 'Location ID')) || 
                        (x !== 'Geocode' && x !== 'Location ID')
                      )"
                  @change="resetValidation($event)"
                  :disabled="withData || isOriginal"
                ></v-combobox>
              </v-flex>
            </v-layout>

            <div v-if="selected !== 'Location ID' && !isOriginal">
              <v-layout v-if="selected === 'Physical Address'">
                <v-flex class="pt-0 pb-0 pr-5 sm-pr-0" sm12>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Search for Address"
                    rules="required"
                  >
                    <v-autocomplete
                      :items="results"
                      label="Search for physical street Address, not PO Box"
                      :search-input.sync="search"
                      v-model="streetAddress"
                      item-text="formatted_address"
                      item-value="formatted_address"
                      @change="completeAddress"
                      persistent-hint
                      autocomplete="off"
                      :error-messages="errors"
                      :disabled="disableSearch"
                      :readonly="isOriginal"
                      no-filter
                      return-object
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-flex>
              </v-layout>

              <v-layout v-if="selected === 'Geocode'">
                <v-flex cols="6" class="mt-0 pb-0">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Latitude"
                    rules="required|between:-180.999999,180.999999"
                  >
                    <v-text-field
                      label="Latitude"
                      v-model="latitude"
                      outlined
                      :error-messages="errors"
                      autocomplete="off"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex cols="6" class="mt-0 pb-0">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Longitude"
                    rules="required|between:-180.999999,180.999999"
                  >
                    <v-text-field
                      label="Longitude"
                      v-model="longitude"
                      outlined
                      :error-messages="errors"
                      autocomplete="off"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
              </v-layout>

              <v-layout v-if="selected === 'GNAF ID'">
                <v-flex cols="12" class="mt-0 pb-0">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="GNAF ID"
                    rules="required"
                  >
                    <v-text-field
                      label="GNAF ID"
                      v-model="gnafId"
                      outlined
                      :error-messages="errors"
                      autocomplete="off"
                      :disabled="disableSearch"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
              </v-layout>

              <v-layout
                v-if="
                  (selected !== 'Location ID' &&
                    $route.path === '/service-qualification-nbn') ||
                  $route.path === '/' ||
                  $route.path === '/nbn-orders'
                "
                ref="action_btns"
              >
                <v-flex class="pt-0 pb-0">
                  <v-btn
                    :disabled="invalid || !dirty || withData || isOriginal"
                    class="primary mr-2"
                    @click="submit()"
                    v-if="showSubmit"
                  >
                    Submit
                  </v-btn>
                  <v-btn
                    :disabled="invalid || !dirty || withData || isOriginal"
                    @click="clear()"
                  >
                    Clear
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex md12 lg5 ref="section1">
            <v-layout>
              <v-radio-group v-model="services" column>
                <v-radio color="#2f5578" value="nbn">
                  <template #label>
                    <div>
                      <strong>Business 'Standard' NBN</strong>
                      <div class="font-weight-regular text-caption caption">
                        Conduct a 'live' service qualification based on
                        Vonex's standard NBN services
                      </div>
                    </div>
                  </template>
                </v-radio>
                <v-radio color="#2f5578" value="5G">
                  <template #label>
                    <div>
                      <strong>Business 5G</strong>
                      <div class="font-weight-regular text-caption caption">
                        Conduct a service qualification for Optus' 5G services
                      </div>
                    </div>
                  </template>
                </v-radio>
                <v-radio color="#2f5578" value="Business Fibre">
                  <template #label>
                    <div>
                      <strong>
                        Business Fibre
                      </strong>
                      <div class="font-weight-regular text-caption caption">
                        Qualify for our faster & more reliable grade of service products.
                      </div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </ValidationObserver>
    <utility-finder-invalid-address
      :show-dialog="showDialog"
      :invalid-items="invalidItems"
      :is-invalid="isInvalid"
      :title="title"
      :is-validated="isValidated"
      @toggleLoading="(val) => $emit('toggleLoading', val)"
      @close="showDialog = false"
    />
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapAddressActions, mapMutations: mapAddressMutations } =
  createNamespacedHelpers(`orders/address`);
const { mapGetters: mapAddressGetters } =
  createNamespacedHelpers(`orders/address`);
const { mapActions: mapSQActions } = createNamespacedHelpers(`orders/sq`);
const { mapActions: mapSQAddressActions } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapMutations: mapSQMutations } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQAddressGetters } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQGetters } = createNamespacedHelpers(`orders/sq`);
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(`orders/featureFlag`);
import Utils from '@/mixins/utils.mixin';
import UtilityFinderInvalidAddress from './utility-finder-invalid-address';
import { Address } from '../../models/Address';

export default {
  name: 'UtilityServiceQualificationForm',
  components: {
    UtilityFinderInvalidAddress,
  },
  mixins: [Utils],
  props: {
    addressList: Array,
    send: Boolean,
    speed: String,
  },
  data() {
    return {
      isDataLoading: false,
      isSaved: false,
      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null,
      streetAddress: null,
      suburb: null,
      state: null,
      postCode: null,
      address: null,
      services: 'nbn',
      items: ['Physical Address', 'Location ID', 'Geocode', 'GNAF ID'],
      selected: 'Physical Address',
      withData: false,
      disableRadio: false,
      longitude: '',
      latitude: '',
      gnafId: '',
      result: {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
        gnafId: '',
      },
      queryAddress: [],
      title: '',
      showDialog: false,
      isValidated: false,
      isInvalid: false,
      invalidItems: [],
    };
  },
  methods: {
    ...mapSQMutations(['SET_FULL_ADDRESS']),
    ...mapAddressActions(['searchAddress', 'createAddress']),
    ...mapSQActions([
      'reset5gSq',
      'resetHasSectorId',
      'addressQuery',
      'serviceQualification5G',
      'setOrderType',
      'setLocationID',
      'resetFormattedSQResult',
      'nbnAddressQuery',
      'serviceQualificationNbn'
    ]),
    ...mapSQAddressActions(['getFullAddress', 'setSearchResultId']),
    submit() {
      let vm = this;
      let payload = {};
      let data = {};
      let methodType = '';
      
      vm.$emit('toggleLoading', true);
      switch (vm.selected) {
        case 'Physical Address':
          methodType = 'PHYSICAL_ADDRESS';

          if (vm.orderType === 'nbn') {
            data = {
              StateOrProvince: vm.fullAddress.state,
              Postcode: vm.fullAddress.postcode,
              Suburb: vm.fullAddress.suburb,
              StreetName: vm.fullAddress.street_name,
              StreetType: vm.fullAddress.street_type,
              StreetNrFirst: vm.fullAddress.street_number,
            };
          } else {
            data = {
              streetAddress: vm.fullAddress.street_address,
              unitNumber: '',
              unitType: '',
              streetNumber: vm.fullAddress.street_number,
              streetName: vm.fullAddress.street_name,
              streetType: vm.fullAddress.street_type,
              streetSuffix: vm.fullAddress.street_suffix,
              suburb: vm.fullAddress.suburb,
              postCode: vm.fullAddress.postcode,
              state: vm.fullAddress.state,
              gNAFIdentifier: vm.fullAddress.gnaf_id,
            };
          }
          break;
        case 'Geocode':
          methodType = 'GEOCODE';
          data = {
            Longtitude: vm.longitude,
            Latitude: vm.latitude,
          };
          break;
        case 'GNAF ID':
          methodType = 'GNAF_ID';

          if (vm.orderType === 'nbn') data = { Gnafld: vm.gnafId };
          else {
            data = {
              gNAFIdentifier: vm.gnafId,
            };
          }
          break;
      }

      if (vm.orderType === 'nbn') {
        payload = {
          addressCheckServiceType: 'NBN',
          addressCheckMethodType: methodType,
          addressValue: data,
        };

        vm.nbnAddressQuery(payload).then((data) => {
          if (data.data.status === 400 && vm.processCount < 2) {
            vm.processCount = vm.processCount + 1;
            vm.redoValidateAddress();
          } else {
            if (data.data) {
              vm.setResult(data.data);
              let details = {
                queryAddress: vm.queryAddress,
                streetAddress: vm.streetAddress,
                populatedAddress: vm.result,
                result: data.data,
              };
              vm.$emit('toggleLoading', false);
              vm.$emit('showResultSection', details);
            }
          }
        });
      }

      if (vm.orderType === '5G') {
        vm.serviceQualification5G(data)
        .then(() => {
          vm.$emit('showResultSection', {});
        })
        .catch((err) => {
          vm.$emit('toggleLoading', false);
        })
        .finally(() => {
          vm.$emit('toggleLoading', false);
        });
      }
      
      if(vm.orderType === 'Business Fibre') {
        vm.sendAddress();
        return;
      }
    },
    redoValidateAddress() {
      let vm = this;
      vm.getAddress();
    },
    setResult(result) {
      let vm = this;
      vm.queryAddress = vm.reformatResult(result);
    },
    reformatResult(result) {
      let newAddress = [];
      result.forEach((x) => {
        let addressFormat = {
          addressSiteName: x.addressSiteName,
          streetNrFirst: x.roadNumber1,
          streetNrLast: x.roadNumber2 ? x.roadNumber2 : '',
          streetName: x.roadName,
          streetType: x.roadTypeCode,
          suburb: x.localityName,
          postcode: x.postcode,
          stateOrProvince: x.stateTerritoryCode,
          longitude: x.longitude,
          latitude: x.latitude,
          locationId: x.id,
          formattedAddress: x.formattedAddress,
          lotNumber: x.lotNumber ? x.lotNumber : '',
        };

        newAddress.push(addressFormat);
      });
      return newAddress;
    },
    setValue(address, name) {
      let value = '';
      address.forEach((x) => {
        if (x.name === name) value = x.value;
      });

      return value;
    },
    clear() {
      let vm = this;
      vm.result = {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
      };
      vm.streetAddress = '';
      vm.longitude = '';
      vm.latitude = '';
      vm.gnafId = '';
      vm.setLocationID('');
      vm.$emit('changed');
      vm.reset5gSq();
      vm.resetFormattedSQResult();
      vm.resetHasSectorId();
    },
    resetValidation(event) {
      let vm = this;
      //TO DO: change path to /service-qualification (feature flag)
      if (vm.$route.path === '/service-qualification-5g') {
        if (event === 'Location ID' || event === 'Geocode') {
          vm.services = 'nbn';
          vm.disableRadio = true;
        } else {
          vm.disableRadio = false;
        }
      }

      vm.latitude = '';
      vm.longitude = '';
      vm.streetAddress = '';
      vm.gnafId = '';
      vm.selected = event;
      vm.result = {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
      };
      vm.setLocationID('');
      vm.resetFormattedSQResult();
      vm.id = '';
      vm.queryAddress = [];
      vm.reset5gSq();
      vm.$emit('changed', event);
      vm.$refs.observer.reset();
    },
    completeAddress(address) {
      let vm = this;
      vm.processCount = 0;
      vm.reset5gSq();
      vm.resetHasSectorId();
      vm.setSearchResultId(address.search_result_id);
      vm.getAddress();
    },
    getAddress() {
      let vm = this;
      vm.getFullAddress().then((addressResults) => {
        if (addressResults.gnafId === '') {
          if (addressResults.state === '') vm.invalidItems.push('state');
          else if (addressResults.postcode === '')
            vm.invalidItems.push('postcode');
          else if (addressResults.suburb === '')
            vm.invalidItems.push('postcode');
          else if (addressResults.street_name === '')
            vm.invalidItems.push('street name');
          else if (addressResults.street_type === '')
            vm.invalidItems.push('street type');
          else if (addressResults.street_number === '')
            vm.invalidItems.push('street number');
          vm.isValidated = true;
          vm.isInvalid = true;
          vm.showAddressDialog('Error Details');
        } else {
          vm.submit();
        }
      });
    },
    showAddressDialog(title) {
      let vm = this;
      vm.title = title;
      vm.showDialog = true;
    },
    showAddressMissing() {
      let vm = this;
      vm.showAddressDialog('Address Not Found');
    },

    addAddressToList() {
      let vm = this;
      if (vm.fullAddress) {
        vm.addressList.push(vm.fullAddress);
        vm.$emit('close');
      }
    },
    sendAddress() {
      let vm = this;
      vm.fullAddress.services = [vm.services];
      if (vm.fullAddress) vm.$emit('sendAddress', vm.fullAddress, vm.speed);
      vm.$emit('toggleLoading', false);
    },
    customFilter(item, queryText, itemText) {
      // return true
      var words = queryText.split(' ').filter((x) => x.length > 0);
      var result = false;
      words.forEach((x) => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    },
    changeServiceType(val) {
      let vm = this;
      vm.setOrderType(val);
      vm.resetValidation('Physical Address');
    },
    checkValues() {
      let vm = this;
      if (!this.isDisabled) vm.$emit('toggleDisabled', true);
      else {
        vm.$emit('toggleDisabled', false);
        vm.$emit('toggleLoading', true);
        vm.submit();
      }
    },
  },
  computed: {
    ...mapSQGetters(['isOriginal', 'orderType']),
    ...mapAddressGetters(['results']),
    ...mapFeatureFlagGetters(['allFlags']),
    isDisabled() {
      switch (this.selected) {
        case 'Geocode':
          return this.latitude != '' && this.longitude != '';
        case 'GNAF ID':
          return this.gnafId != '';
      }

      return false;
    },
    isGoogleChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    showSubmit() {
      let vm = this;
      // return vm.services === 'Business Fibre';
      if (vm.selected === "Geocode" || vm.selected === "GNAF ID") {
        return true;
      } else {
        return false;
      }
    },
    disableSearch() {
      let vm = this;
      if (vm.$route.path === '/') {
        return false;
      } else {
        return vm.withData || vm.services === '';
      }
    },
    ...mapSQAddressGetters(['fullAddress', 'addressResults']),
  },
  watch: {
    search(val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
    services(val) {
      let vm = this;
      vm.changeServiceType(val);
      vm.$refs.observer.reset();
      return val;
    },
    checkType() {
      let vm = this;
      vm.clear();
    },

    selected() {
      let vm = this;
      vm.streetAddress = '';
      if (vm.selected === 'Location ID') vm.$emit('toggleInput', true);
      else vm.$emit('toggleInput', false);
    },
  },
  mounted() {
    let vm = this;
    vm.reset5gSq();
    vm.changeServiceType('nbn');
    const section1 = this.$refs.section1;
    const section2 = this.$refs.section2;
    if (window.innerWidth <= 1263 && section1 && section2) {
      section2.parentNode.insertBefore(section1, section2);
    }
    if (window.innerWidth >= 1263 && section1 && section2) {
      section2.parentNode.insertAfter(section1, section2);
    }
  },
};
</script>
